<script>
import { mapGetters } from "vuex";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn
} from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from '/src/config/client';

export default {
  name: "WelcomePanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn
  },

  data() {
    return {
      clientConfig
    }
  },

  computed: {
    ...mapGetters([
      "debugMode"
    ])
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");
      
      this.triggerHeightCheck();
      
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },
  }
};
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0">
      <MDBCol 
        md="11"
        class="main-content-wrapper"
      >
        <div class="intro-banner"></div>
        <div class="intro-text">
          <div v-html="clientConfig.content.welcome.bannerHeading"></div>
          <div v-html="clientConfig.content.welcome.content"></div>
        </div>
        <!-- // -->

        <MDBRow>
          <MDBCol
            md="11"
            class="text-center mx-auto my-5"
          >
            <MDBBtn
              class="btn-primary rounded intro-btn"
              @click="clickToTab(2)"
              aria-label="Continue button"
            >
              {{ clientConfig.content.welcome.buttonLabel }}
            
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div 
          v-if="clientConfig.content.welcome.footerDisclaimer"
          class="homepage-footer-disclaimer"
          v-html="clientConfig.content.welcome.footerDisclaimer"
        ></div>

      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>